import _ from 'lodash';

import * as t from './action_types';

const initState = {
  dashboard: null,
  housekeeping: null,
  inspection: null,
  maintenance: null,
  schedule: null,
};

export default (state = initState, action) => {
  const { payload, type } = action;
  switch (type) {
    case t.SET_SELECTED_VIEW: {
      const view = _.get(payload, 'view');
      const viewName = _.get(payload, 'viewName');
      return {
        ...state,
        [viewName]: view,
      };
    }
    default:
      return state;
  }
};
